<template>
  <div class="eventLog">
    <h1>Event Log</h1>
    <el-form :inline="true" :model="eventForm" ref="eventForm" class="form-inline">

      <el-cascader :options="options" ref="eventCascader" @change="elCascaderOnlick" :show-all-levels="false" placeholder="Select Event Type"></el-cascader>

      <!-- <el-date-picker v-show="showDataPicker" v-model="dataRangeValue" type="daterange" value-format="timestamp" range-separator="To"
                      start-placeholder="Start Date" end-placeholder="End Date">
      </el-date-picker>-->

      <el-date-picker v-show="showDataPicker" v-model="dataRangeValue" type="daterange" value-format="timestamp" range-separator="To"
                      start-placeholder="Start Date" end-placeholder="End Date">
      </el-date-picker>

      <el-form-item>
        <el-button type="success" plain @click="onSubmit" :loading="searching">Search</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="eventData" v-show="showEventLog" v-loading="searching"
              @cell-click="handleCellClick"
              style="width: 100%" :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}"
              :cell-style="cellStyle">
      <el-table-column prop="event_type" label="Event Type" :formatter="eventTypeFormat"></el-table-column>
      <el-table-column prop="event_time" label="Event Time [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
      <el-table-column prop="user_name" label="User Name"></el-table-column>
      <el-table-column prop="method" label="Event Method"></el-table-column>
      <el-table-column prop="desc" label="Event Description"></el-table-column>
      <el-table-column prop="result" label="Event Result" :formatter="eventResultFormat"></el-table-column>
      <el-table-column prop="detail" label="Event Detail" :formatter="eventDetailFormat"></el-table-column>
    </el-table>

    <!-- Event Detail Dialog -->
    <el-dialog title="Event Detail" :visible.sync="dialogTableVisible">
      <el-table :data="dialogData" :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="outerlicense" label="Outer License"></el-table-column>
        <el-table-column prop="interlicense" label="Inter License"></el-table-column>
        <el-table-column prop="er_num" label="ER Number" :formatter="arrayFormat"></el-table-column>
        <el-table-column prop="license_content" label="License Content" :formatter="jsonFormat"></el-table-column>
        <el-table-column prop="project" label="Project Name"></el-table-column>
        <el-table-column prop="direct_cus" label="Direct Customer"></el-table-column>
        <el-table-column prop="user_email" label="Customer Email"></el-table-column>
        <el-table-column prop="exp_date" label="Expiry Date [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
      </el-table>
    </el-dialog>

    <el-pagination
      v-show="showEventLog"
      @current-change="handleCurrentChange"
      :current-page=curPage
      layout="total, prev, pager, next, jumper"
      :total=numOfData>
    </el-pagination>
  </div>
</template>

<script>
import {searchEventLog, searchEventLogByPage} from '../api'
import moment from 'moment'
export default {
  name: 'EventLog',
  data () {
    return {
      searching: false,
      showDataPicker: false,
      showEventLog: false,
      dialogTableVisible: false,
      dialogData: [],
      eventData: [],
      eventForm: {},
      options: [{
        value: 'event_type',
        label: 'Event Type',
        children: [{
          value: 'generate',
          label: 'Generate'
        }, {
          value: 'modify',
          label: 'Modify'
        }, {
          value: 'append',
          label: 'Append'
        }, {
          value: 'delete',
          label: 'Delete'
        }]
      }, {
        value: 'event_time',
        label: 'Date'
      }],
      searchParams: {
        search_type: null,
        search_word: null,
        from_time: null,
        to_time: null,
        page: null
      },
      eventCascader: null,
      dataRangeValue: null,
      numOfData: 0,
      numOfPage: 0,
      curPage: 1
    }
  },
  created: function () {
    this.searching = false
    this.showDataPicker = false
    this.showEventLog = false
  },
  methods: {
    onSubmit () {
      let _this = this
      this.$refs.eventForm.validate((valid) => {
        if (valid) {
          _this.searching = true

          console.log('dataRangeValue = ')
          console.log(_this.dataRangeValue)

          _this.searchParams.search_word = _this.searchParams.search_type === 'event_type' ? _this.$refs['eventCascader'].getCheckedNodes()[0].value : null
          _this.searchParams.from_time = _this.searchParams.search_type === 'event_time' ? _this.dataRangeValue[0] : null
          _this.searchParams.to_time = _this.searchParams.search_type === 'event_time' ? _this.dataRangeValue[1] : null

          searchEventLog(_this.searchParams).then(data => {
            _this.searching = false
            _this.eventData = data.event_record
            _this.showEventLog = true
            _this.numOfData = data.count
            _this.numOfPage = data.pagecount
            _this.curPage = 1

            console.log('searchEventLog Success')
            console.log('searchEventLog Success -> data.data')
            console.log(data)
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            _this.searching = false
            _this.showEventLog = false
            _this.numOfData = 0
            _this.numOfPage = 0
            _this.curPage = 1
          })
        } else {
          console.log('error searching!!')
          return false
        }
      })
    },
    elCascaderOnlick (value) {
      let _this = this
      _this.searchParams.search_type = value[0]
      _this.showDataPicker = value[0] === 'event_time'
      if (_this.showDataPicker) {
        // Set default range of past 30 days
        _this.dataRangeValue = [new Date().getTime() - 30 * 24 * 3600 * 1000, new Date().getTime()]
      }
    },
    handleCellClick (row, column, cell, event) {
      if (column.property === 'detail') {
        var jsonObj = row['detail']
        this.dialogTableVisible = true
        this.dialogData = [jsonObj]
      }
    },
    handleCurrentChange (val) {
      let _this = this
      _this.searching = true
      _this.searchParams.page = val
      _this.searchParams.search_word = _this.searchParams.search_type === 'event_type' ? _this.$refs['eventCascader'].getCheckedNodes()[0].value : null
      _this.searchParams.from_time = _this.searchParams.search_type === 'event_time' ? _this.dataRangeValue[0] : null
      _this.searchParams.to_time = _this.searchParams.search_type === 'event_time' ? _this.dataRangeValue[1] : null

      searchEventLogByPage(_this.searchParams).then(data => {
        console.log('searchEventLogByPage Succeed')
        console.log(data)

        _this.searching = false
        _this.eventData = data.event_record
        _this.showEventLog = true
        _this.numOfData = data.count
        _this.numOfPage = data.pagecount
        _this.curPage = val
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        _this.searching = false
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      let date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss', true)
    },
    eventTypeFormat: function (row, column) {
      let eventType = row[column.property]
      switch (eventType) {
        case 1: return 'Generate'
        case 2: return 'Modify'
        case 3: return 'Append'
        case 4: return 'Delete'
        default: return 'Error Type'
      }
    },
    eventResultFormat: function (row, column) {
      let eventResult = row[column.property]
      switch (eventResult) {
        case 0: return 'Success'
        case 1: return 'Fail'
        default: return 'Error Type'
      }
    },
    eventDetailFormat: function (row, column) {
      // Show content in Dialog instead
      return 'Click to View Details'
    },
    jsonFormat: function (row, column) {
      let jsonObj = row[column.property]
      return JSON.stringify(jsonObj)
    },
    cellStyle (row, column, rowIndex, columnIndex) {
      if (row) {
        if (row.column.property === 'detail') {
          return 'text-decoration: underline; color: #5fca37; textAlign: center'
        }
        return 'textAlign: center'
      }
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 50px;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// EventLog.vue?17fabea2